module.exports = "/_next/static/images/placeholder-34f6ae5a9122c1ec4226232c9f7b82ae.jpg";